import * as Dialog from '@radix-ui/react-dialog';
import { MobileAnimationSidebar } from '@trwl/shared/ui/sidebar/mobileAnimationSidebar';
import { SidebarAnimation } from '@trwl/shared/ui/sidebar/sidebarAnimation';
import cn from 'classnames';
import { motion } from 'framer-motion';
import { isMobile } from 'react-device-detect';

import css from './sidebar.module.scss';

export const Sidebar = {
  Content: ({ className, ...props }: Dialog.DialogContentProps) => (
    <Dialog.Content
      {...props}
      className={cn(
        'flex flex-col h-full fixed r-0 bg-white',
        className,
        css.mobileSidebar,
      )}
    >
      <motion.div
        variants={isMobile ? MobileAnimationSidebar : SidebarAnimation}
        initial="initial"
        animate="animate"
        exit="exit"
      >
        {props.children}
      </motion.div>
    </Dialog.Content>
  ),
};
